import vue from "vue"

vue.filter('currency', value => value + "€")